export const defaultPrimaryColor = '#ff9900';
export const messageNotAuthorize = "common.utils.const.notAuthorize";